var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgQuestionmarkDiamondFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.57 12.53a.75.75 0 0 1 0-1.06l9.9-9.9a.75.75 0 0 1 1.06 0l9.9 9.9a.75.75 0 0 1 0 1.06l-9.9 9.9a.75.75 0 0 1-1.06 0l-9.9-9.9Zm9.179-2.632c0-.43.14-.729.33-.92.19-.19.49-.33.92-.33.43 0 .73.14.92.33.19.191.33.49.33.92 0 .083-.033.206-.173.402-.144.202-.347.407-.607.668l-.02.02c-.236.236-.524.523-.748.837-.235.329-.452.756-.452 1.273v.4a.75.75 0 0 0 1.5 0v-.4c0-.082.033-.205.173-.401.144-.203.347-.408.607-.668l.02-.02c.236-.236.524-.524.748-.837.235-.33.452-.756.452-1.274 0-.77-.26-1.47-.77-1.98s-1.21-.77-1.98-.77-1.47.26-1.98.77-.77 1.21-.77 1.98a.75.75 0 0 0 1.5 0Zm1.25 5.053a.95.95 0 1 0 0 1.9.95.95 0 0 0 0-1.9Z", fill: "currentColor" })));
});
export default SvgQuestionmarkDiamondFill;
